import { Field } from 'Util/Query';

/** @namespace Insign/Query/SwissPost/Query */
export class SwissPostQuery {
    getAutocompleteZipQuery(zipCity) {
        return new Field('autocompleteZip')
            .addArgument('zipCity', 'String', zipCity)
            .addFieldList([
                'city18',
                'city27',
                'zip'
            ]);
    }

    getAutocompleteStreetQuery(zipCity) {
        return new Field('autocompleteStreet')
            .addArgument('zipCity', 'String', zipCity);
    }

    getValidateShippingAddressQuery(address) {
        return new Field('validateShippingAddress')
            .addArgument('address', 'InputAddressToValidate', address);
    }
}

export default new SwissPostQuery();
